import { render, staticRenderFns } from "./BannerModalDialog.vue?vue&type=template&id=8e5527b6&scoped=true&"
import script from "./BannerModalDialog.vue?vue&type=script&lang=js&"
export * from "./BannerModalDialog.vue?vue&type=script&lang=js&"
import style0 from "./BannerModalDialog.vue?vue&type=style&index=0&id=8e5527b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5527b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e5527b6')) {
      api.createRecord('8e5527b6', component.options)
    } else {
      api.reload('8e5527b6', component.options)
    }
    module.hot.accept("./BannerModalDialog.vue?vue&type=template&id=8e5527b6&scoped=true&", function () {
      api.rerender('8e5527b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/BannerModalDialog.vue"
export default component.exports